import { productDecode } from '@/lib/shopify/gid';

/**
 * This is similar to `mergeGwpItemsIntoList` but specifically adds a few more
 * bundle properties and is slightly simpler due to the simpler structure of
 * the gwp settings object used with bundles.
 */
export const mergeBundleGwpItemsIntoList = (
  itemListToUpdate,
  gwpOptionManager,
  selectedOption,
  bundleName,
  bundleId
) => {
  // Find info about the gwp for the selected variant
  const matchingGwpSettings = gwpOptionManager.variant_settings?.find(
    (option) => option?.parent_variant === selectedOption
  );

  // Find the parent-to-be of the GWP items
  const gwpParentLineItem = itemListToUpdate.find((item) =>
    item.customAttributes.find(
      (attr) => attr.key === '_gwpParentProduct' && attr.value === 'true'
    )
  );

  if (!matchingGwpSettings || !gwpParentLineItem) {
    return itemListToUpdate;
  }

  // Create gwp payloads to add to the list and return
  const resultList = [...itemListToUpdate];
  gwpOptionManager.products.forEach((product, index) => {
    const thisGwpSettings = matchingGwpSettings.gwp_settings?.[index];
    if (!thisGwpSettings) {
      return;
    }

    const gwpVariantTitle = `${thisGwpSettings.gwp_size}${
      thisGwpSettings.gwp_secondary_attribute
        ? ` / ${thisGwpSettings.gwp_secondary_attribute}`
        : ''
    }`;
    const gwpVariant = product.variants.find(
      (variant) => variant.title === gwpVariantTitle
    );

    if (gwpVariant) {
      const gwpPayload = createGwpPayload(
        product,
        thisGwpSettings,
        gwpVariant,
        gwpParentLineItem,
        bundleName,
        bundleId
      );

      resultList.push(gwpPayload);
    }
  });

  return resultList;
};

function createGwpPayload(
  gwpProduct,
  gwpProductSettings,
  gwpVariant,
  parentLineItem,
  bundleName,
  bundleId
) {
  const quantity = parseInt(gwpProductSettings.gwp_quantity) || 1;
  return {
    variant: gwpVariant,
    product: gwpProduct,
    quantity,
    customAttributes: [
      { key: '_isPromo', value: 'true' },
      { key: '_promoType', value: 'free' },
      { key: '_promoParent', value: parentLineItem.product.id },
      {
        key: '_productImage',
        value: gwpProduct.thumbnailImage?.url ?? gwpProduct.featuredImage.url
      },
      { key: '_productPosition', value: '0' },
      { key: '_productTitle', value: gwpProduct.title },
      { key: '_productType', value: gwpProduct.productType },
      { key: '_compareAtPrice', value: gwpVariant.compareAtPrice?.amount },
      {
        key: '_validPromoMultiplier',
        value: quantity.toString()
      },
      {
        key: '_promoParentVariantId',
        value: productDecode(parentLineItem.variant.id)?.id
      },
      { key: '_gwpOptionItShouldBe', value: gwpVariant.title },
      {
        key: '_gwpQuantity',
        value: quantity.toString()
      },
      {
        key: '_bundleId',
        value: bundleId
      },
      { key: 'Bundle', value: bundleName },
      { key: '_bundleDiscountAmount', value: '0' }
    ]
  };
}
